import { useState } from "react";

export function usePlayerStats() {
  const [players, setPlayers] = useState({});

  // ---------------------------
  // INIT PLAYER
  // ---------------------------
  const initPlayer = (player) => {
    if (!player?.player_id) return;

    setPlayers((prev) => ({
      ...prev,
      [player.player_id]: {
        player_id: player.player_id,
        name: player.name,
        runs: 0,
        balls: 0,
        fours: 0,
        sixes: 0,
        out: false,
      },
    }));
  };


  const resetPlayers = () => {
  setPlayers({});
};
  // ---------------------------
  // ADD BATTING EVENT
  // ---------------------------
  const addBattingEvent = (playerId, runs, isLegal) => {
    setPlayers((prev) => {
      const p = prev[playerId];
      if (!p || p.out) return prev;

      return {
        ...prev,
        [playerId]: {
          ...p,
          runs: p.runs + runs,
          balls: isLegal ? p.balls + 1 : p.balls,
          fours: runs === 4 ? p.fours + 1 : p.fours,
          sixes: runs === 6 ? p.sixes + 1 : p.sixes,
        },
      };
    });
  };

  // ---------------------------
  // WICKET
  // ---------------------------
  const setOut = (playerId) => {
    setPlayers((prev) => ({
      ...prev,
      [playerId]: {
        ...prev[playerId],
        out: true,
      },
    }));
  };

  return {
    players,
    initPlayer,
    addBattingEvent,
    setOut,
    resetPlayers
  };
}
